import React from 'react';

export const SquareIcon = ({ checked, className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={{ width: '1em', height: '1em', ...style }} fill="currentColor">
    {checked ? (
      <path d="M19,3H5C3.89,3,3,3.89,3,5v14c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.89,20.1,3,19,3z M10,17l-5-5l1.41-1.41L10,14.17 l7.59-7.59L19,8L10,17z" />
    ) : (
      <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
    )}
  </svg>
);

export const ExportIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={{ width: '1em', height: '1em', ...style }} fill="currentColor">
    <path d="M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z" />
  </svg>
);

export const PdfIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={{ width: '1em', height: '1em', ...style }} fill="currentColor">
    <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z" />
  </svg>
);

export const EditIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={{ width: '1em', height: '1em', ...style }} fill="currentColor">
    <path d="M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z" />
    <path fillOpacity=".36" d="M0 20h24v4H0z" />
  </svg>
);

export const TrashIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={{ width: '1em', height: '1em', ...style }} fill="currentColor">
    <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1z" />
  </svg>
);

export const CancelIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={{ width: '1em', height: '1em', ...style }} fill="currentColor">
    <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
  </svg>
);

export const ArchiveIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={{ width: '1em', height: '1em', ...style }} fill="currentColor">
    <path d="M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z" />
  </svg>
);

export const UnarchiveIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={{ width: '1em', height: '1em', ...style }} fill="currentColor">
    <path d="M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.81-1h12l.94 1H5.12z" />
  </svg>
);

export const MergeIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} style={{ width: '1em', height: '1em', ...style }} fill="currentColor">
    <path d="M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v2H7.5C5.57 8 4 9.57 4 11.5S5.57 15 7.5 15H11v2H7.5C4.46 17 2 14.54 2 11.5S4.46 6 7.5 6H13V2l5 5-5 5V8H7.5z" />
  </svg>
);
